import defaultAvatar from '@/common/image/avatar.png'
const state = {
  defaultAvatar: defaultAvatar,
  loading: true
}

export default state
